import type { PaySheet, SavePaySheetRequest } from '@pay-plan/shared';
import { apiRequest } from './client.js';

function paySheetBase(
  locationId: string,
  employeeId: string,
  year: number,
  month?: number,
): string {
  const loc = encodeURIComponent(locationId);
  const emp = encodeURIComponent(employeeId);
  return month === undefined
    ? `/locations/${loc}/employees/${emp}/years/${year}/pay-sheets`
    : `/locations/${loc}/employees/${emp}/years/${year}/months/${month}/pay-sheet`;
}

export async function listPaySheets(
  locationId: string,
  employeeId: string,
  year: number,
): Promise<PaySheet[]> {
  const res = await apiRequest<{ paySheets: PaySheet[] }>(
    'GET',
    paySheetBase(locationId, employeeId, year),
  );
  return res.paySheets;
}

export async function getPaySheet(
  locationId: string,
  employeeId: string,
  year: number,
  month: number,
): Promise<PaySheet> {
  const res = await apiRequest<{ paySheet: PaySheet }>(
    'GET',
    paySheetBase(locationId, employeeId, year, month),
  );
  return res.paySheet;
}

export async function savePaySheet(
  locationId: string,
  employeeId: string,
  year: number,
  month: number,
  data: SavePaySheetRequest,
): Promise<PaySheet> {
  const res = await apiRequest<{ paySheet: PaySheet }>(
    'PUT',
    paySheetBase(locationId, employeeId, year, month),
    data,
  );
  return res.paySheet;
}

export async function completePaySheet(
  locationId: string,
  employeeId: string,
  year: number,
  month: number,
): Promise<PaySheet> {
  const res = await apiRequest<{ paySheet: PaySheet }>(
    'POST',
    `${paySheetBase(locationId, employeeId, year, month)}/complete`,
  );
  return res.paySheet;
}

export async function deletePaySheet(
  locationId: string,
  employeeId: string,
  year: number,
  month: number,
): Promise<void> {
  await apiRequest('DELETE', paySheetBase(locationId, employeeId, year, month));
}

export async function countEmployeePaySheets(
  locationId: string,
  employeeId: string,
): Promise<number> {
  const loc = encodeURIComponent(locationId);
  const emp = encodeURIComponent(employeeId);
  const res = await apiRequest<{ count: number }>(
    'GET',
    `/locations/${loc}/employees/${emp}/pay-sheets/count`,
  );
  return res.count;
}
